// Module
var code = "<svg viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13 8l-3-3-3 3h6zm-.1 4L10 14.9 7.1 12h5.8z\" fill=\"#637381\" fill-rule=\"evenodd\"/></svg>";
// Exports
module.exports = code;